import {
	ActivityIndicator,
	type ActivityIndicatorProps,
} from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type Props = ActivityIndicatorProps & {
	isFullScreen?: boolean;
};

const Loader = ({ isFullScreen = false, ...activityIndicatorProps }: Props) => {
	const theme = useAppTheme();
	return (
		<Box
			flex={1}
			alignItems="center"
			justifyContent="center"
			backgroundColor={isFullScreen ? theme.colors.background : undefined}
		>
			<ActivityIndicator
				color={theme.colors.primary}
				size={activityIndicatorProps.size || "large"}
				{...activityIndicatorProps}
			/>
		</Box>
	);
};

export default Loader;
